import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './Common/MainLayout';
import PublicClientDataRequest from './Components/Practices/PublicClientDataRequest';

const App = () => {
    return (
        <Routes>
            <Route path="/data-request/:token" element={<PublicClientDataRequest />} />
            <Route path="/data-request/*" element={<PublicClientDataRequest />} />
            <Route path="/data-request" element={<PublicClientDataRequest />} />
            <Route path="*" element={<MainLayout />} />
        </Routes>
    );
}

export default App;
